export class FlashService {
  static $inject = ['$rootScope'];

  queue = [];
  currentMessage = '';

  constructor(private $rootScope) {
    // locationChangeStart
    this.$rootScope.$on('$routeChangeStart', () => {
      this.currentMessage = this.queue.shift() || '';
    });
  }

  setMessage(message) {
    this.queue.push(message);
  }

  getMessage() {
    return this.currentMessage;
  }

  clearMessage() {
    this.queue = [];
    this.currentMessage = '';
    return '';
  }
}
